import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'

import axios from 'axios'
import VueAxios from 'vue-axios'
Vue.use(VueAxios, axios)

import { BootstrapVue, IconsPlugin } from 'bootstrap-vue'
Vue.use(BootstrapVue)
Vue.use(IconsPlugin)

//import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'

import { util } from './util.js'
Vue.prototype.$util = util

Vue.config.productionTip = false


Vue.directive('uppercase', {
  bind(el) {
    el.addEventListener('keyup', () => {
      el.value = el.value.toUpperCase();
    })
  }
})

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
